import { render, staticRenderFns } from "./DfmAdLarge.vue?vue&type=template&id=209e81eb&scoped=true"
import script from "./DfmAdLarge.vue?vue&type=script&lang=js"
export * from "./DfmAdLarge.vue?vue&type=script&lang=js"
import style0 from "./DfmAdLarge.vue?vue&type=style&index=0&id=209e81eb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e81eb",
  null
  
)

export default component.exports